// const $bodyOnePlusSelector = $('.ryobi-oneplus');
const $toggleDetails = $('.js-toggle-details');

if ($toggleDetails.length > 0) {
  const accordionToggleClass = 'toggle-details--open';

  $toggleDetails.on('click tap', function click() {
    $(this).toggleClass(accordionToggleClass);
  });
}

const $bodyQuikMowSelector = $('.quickmow');

if ($bodyQuikMowSelector.length > 0) {
  // const $toggleDetails = $('.js-toggle-details');
  const accordionToggleClass = 'toggle-details--open';

  $toggleDetails.on('click tap', function click() {
    $(this).toggleClass(accordionToggleClass);
  });
}
